// @flow

export const ALLOWED_SET_PROPERTIES = ['label', 'placeholder', 'required'];

export const EQUALS = 'equals';
export const DOES_NOT_EQUAL = 'doesNotEqual';
export const GREATER_THAN = 'greaterThan';
export const GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual';
export const LESS_THAN = 'lessThan';
export const LESS_THAN_OR_EQUAL = 'lessThanOrEqual';
export const CONTAINS = 'contains';
export const DOES_NOT_CONTAIN = 'doesNotContain';
export const BEGINS_WITH = 'beginsWith';
export const ENDS_WITH = 'endsWith';
export const IS_EMPTY = 'isEmpty';
export const IS_NOT_EMPTY = 'isNotEmpty';
export const IS_CHANGED = 'isChanged';

export type OperatorType =
  | typeof EQUALS
  | typeof DOES_NOT_EQUAL
  | typeof GREATER_THAN
  | typeof GREATER_THAN_OR_EQUAL
  | typeof LESS_THAN
  | typeof LESS_THAN_OR_EQUAL
  | typeof CONTAINS
  | typeof DOES_NOT_CONTAIN
  | typeof BEGINS_WITH
  | typeof ENDS_WITH
  | typeof IS_EMPTY
  | typeof IS_NOT_EMPTY
  | typeof IS_CHANGED;

export const Operators = {
  EQUALS,
  DOES_NOT_EQUAL,
  GREATER_THAN,
  GREATER_THAN_OR_EQUAL,
  LESS_THAN,
  LESS_THAN_OR_EQUAL,
  CONTAINS,
  DOES_NOT_CONTAIN,
  BEGINS_WITH,
  ENDS_WITH,
  IS_EMPTY,
  IS_NOT_EMPTY,
  IS_CHANGED,
};

export const OperatorDisplayTexts: { [string]: string } = {
  [Operators.EQUALS]: 'Equals',
  [Operators.DOES_NOT_EQUAL]: 'Does Not Equal',
  [Operators.GREATER_THAN]: 'Greater Than',
  [Operators.GREATER_THAN_OR_EQUAL]: 'Greater Than or Equal',
  [Operators.LESS_THAN]: 'Less Than',
  [Operators.LESS_THAN_OR_EQUAL]: 'Less Than or Equal',
  [Operators.CONTAINS]: 'Contains',
  [Operators.DOES_NOT_CONTAIN]: 'Does Not Contain',
  [Operators.BEGINS_WITH]: 'Begins With',
  [Operators.ENDS_WITH]: 'Ends With',
  [Operators.IS_EMPTY]: 'Is Empty',
  [Operators.IS_NOT_EMPTY]: 'Is Not Empty',
  [Operators.IS_CHANGED]: 'Is Changed',
};

export const OperatorsRequiringValue: Array<string> = [
  Operators.EQUALS,
  Operators.DOES_NOT_EQUAL,
  Operators.GREATER_THAN,
  Operators.GREATER_THAN_OR_EQUAL,
  Operators.LESS_THAN,
  Operators.LESS_THAN_OR_EQUAL,
  Operators.CONTAINS,
  Operators.DOES_NOT_CONTAIN,
  Operators.BEGINS_WITH,
  Operators.ENDS_WITH,
];

export const SET_INITIAL_LOGICS = 'SET_INITIAL_LOGICS';
export const SET_FORM_FIELDS = 'SET_FORM_FIELDS';
export const ADD_LOGIC = 'ADD_LOGIC';
export const SET_SELECTED_LOGIC_ID = 'SET_SELECTED_LOGIC_ID';
export const SET_SELECTED_LOGIC = 'SET_SELECTED_LOGIC';
export const UPDATE_MATCH_CONDITIONS = 'UPDATE_MATCH_CONDITIONS';
export const ADD_CONDITION = 'ADD_CONDITION';
export const DELETE_CONDITION = 'DELETE_CONDITION';
export const UPDATE_CONDITION = 'UPDATE_CONDITION';
export const ADD_OUTCOME = 'ADD_OUTCOME';
export const DELETE_OUTCOME = 'DELETE_OUTCOME';
export const ADD_ACTION = 'ADD_ACTION';
export const UPDATE_ACTION = 'UPDATE_ACTION';
export const DELETE_ACTION = 'DELETE_ACTION';

// Action categories
export const ACTIONS = 'actions';
export const ELSE_ACTIONS = 'elseActions';

export type ActionCategory = typeof ACTIONS | typeof ELSE_ACTIONS;

// Action button definitions
export const ACTION_TYPE_SHOW_HIDE = 'showHide';
export const ACTION_TYPE_ENABLE_DISABLE = 'enableDisable';
export const ACTION_TYPE_SET_VALUE = 'setValue';
export const ACTION_TYPE_VALIDATE = 'validate';
export const ACTION_TYPE_SET_PROPERTY = 'setProperty';

export const ActionTypes = {
  SHOW_HIDE: ACTION_TYPE_SHOW_HIDE,
  ENABLE_DISABLE: ACTION_TYPE_ENABLE_DISABLE,
  SET_VALUE: ACTION_TYPE_SET_VALUE,
  VALIDATE: ACTION_TYPE_VALIDATE,
  SET_PROPERTY: ACTION_TYPE_SET_PROPERTY,
};

export type ActionType = $Values<typeof ActionTypes>;

export const ACTION_LABEL_SHOW_HIDE = 'Show/Hide';
export const ACTION_LABEL_ENABLE_DISABLE = 'Enable/Disable';
export const ACTION_LABEL_SET_VALUE = 'Set Value';
export const ACTION_LABEL_VALIDATE = 'Validate';
export const ACTION_LABEL_SET_PROPERTY = 'Set Property';

export const ActionLabels = {
  [ActionTypes.SHOW_HIDE]: ACTION_LABEL_SHOW_HIDE,
  [ActionTypes.ENABLE_DISABLE]: ACTION_LABEL_ENABLE_DISABLE,
  [ActionTypes.SET_VALUE]: ACTION_LABEL_SET_VALUE,
  [ActionTypes.VALIDATE]: ACTION_LABEL_VALIDATE,
  [ActionTypes.SET_PROPERTY]: ACTION_LABEL_SET_PROPERTY,
};
